// AI-ASSISTED: generated with claude-code on 2026-06-10, reviewed by Yoann Hertienne
import Button from '@mui/material/Button';
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import { useEntity } from '@backstage/plugin-catalog-react';
import { TileBoundary } from '../team-landing/TileBoundary';

const LEANIX_ANNOTATION = 'leanix.net/factsheet-id';
const LEANIX_BASE = 'https://luminus.leanix.net/Inventory/Show';

const LeanIxCardBody = () => {
  const { entity } = useEntity();
  const factsheetId = entity.metadata.annotations?.[LEANIX_ANNOTATION];
  if (!factsheetId) return null;
  return (
    <Card variant="outlined">
      <CardContent>
        <Typography variant="h6">LeanIX</Typography>
        <Typography variant="body2" color="text.secondary">
          Architecture FactSheet for this component.
        </Typography>
      </CardContent>
      <CardActions>
        <Button
          variant="outlined"
          size="small"
          href={`${LEANIX_BASE}/${encodeURIComponent(factsheetId)}`}
          target="_blank"
          rel="noreferrer"
          aria-label="Open LeanIX FactSheet for this component"
        >
          Open FactSheet
        </Button>
      </CardActions>
    </Card>
  );
};

export const LeanIxCard = () => (
  <TileBoundary tool="LeanIX">
    <LeanIxCardBody />
  </TileBoundary>
);
